/* ==========================================================================
   TUCANO · Behaviors layer
   Vanilla JS, no deps. Loaded once (defer).
   ========================================================================== */

(function() {
  'use strict';

  /* ---- Reveal on scroll ---- */
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.1,
    });

    const observe = () => {
      document.querySelectorAll('.tcn-reveal:not(.is-visible), .tcn-reveal-stagger:not(.is-visible)').forEach((el) => {
        revealObserver.observe(el);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observe);
    } else {
      observe();
    }

    // Observe nodes inserted later (e.g. via Theme editor / sections rendering API)
    const mutationObserver = new MutationObserver((mutations) => {
      let needsRescan = false;
      mutations.forEach((m) => {
        if (m.addedNodes.length) needsRescan = true;
      });
      if (needsRescan) observe();
    });
    mutationObserver.observe(document.body || document.documentElement, {
      childList: true,
      subtree: true,
    });
  } else {
    // Reduced motion / no IO: show everything
    document.documentElement.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll('.tcn-reveal, .tcn-reveal-stagger').forEach((el) => el.classList.add('is-visible'));
    });
  }

  /* ---- Marquee speed adjust (pause on hover via CSS, but here we sync duplicate) ---- */
  document.querySelectorAll('.tcn-marquee').forEach((marquee) => {
    const track = marquee.querySelector('.tcn-marquee__track');
    if (!track) return;
    // Duplicate content for seamless loop
    const clone = track.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    marquee.appendChild(clone);
  });

  /* ---- Header scroll state ---- */
  let lastScrollY = 0;
  const updateHeaderScroll = () => {
    const y = window.scrollY;
    const header = document.querySelector('header-component, #header-group');
    if (header) {
      header.classList.toggle('tcn-scrolled', y > 24);
      header.classList.toggle('tcn-scroll-up', y < lastScrollY);
    }
    lastScrollY = y;
  };
  if ('requestIdleCallback' in window) {
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          updateHeaderScroll();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }
  updateHeaderScroll();
})();
